import { kebabToCamelCase } from '@/utility/kebabToCamelCase';
import { kebabToPascalCase } from '@/utility/kebabToPascalCase';

export const createFormName = (parent: string, child: string): string =>
  [kebabToCamelCase(parent), kebabToPascalCase(child)].join('');
